import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {connect} from 'react-redux'
import {Grid, Col, Row} from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import HorseDetails from './HorseDetails'
import HorseChildren from './HorseChildren'
import HorseBreederOwner from './HorseBreederOwner/HorseBreederOwner'
import HorsePhotos from './HorsePhotos'
import HorseLoading from '../Common/HorseLoading/HorseLoading'
import NotFound from '../Common/NotFound/NotFound'

import './Layout/HorseInfo.css'

class HorseInfoScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      info: {},
      isLoading: true,
      showNotFound: false,
      infoItem: null
    }
  }

  componentWillMount () {
    this.setState({isLoading: false, showNotFound: false, info: this.props.currentHorse})
    if (window.__BROWSER_ENV__) {
      this.setState({isLoading: true, showNotFound: false})
      Actions.horseInfo(this.props.params.key).catch((e) => {
        if (e.response && e.response.status === 404) {
          this.setState({showNotFound: true, isLoading: false})
        }
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.currentHorse) {
      if (nextProps.currentHorse.key !== nextProps.params.key) {
        return this.setState({isLoading: true}, () => Actions.horseInfo(nextProps.params.key).catch((e) => {
          if (e.response && e.response.status === 404) {
            this.setState({showNotFound: true, isLoading: false})
          }
        }))
      }
      return this.setState({info: nextProps.currentHorse, isLoading: false, showNotFound: false})
    }
    this.setState({isLoading: true})
    Actions.horseInfo(nextProps.params.key).then(data => {
      this.setState({info: data, isLoading: false, showNotFound: false})
    }).catch((error) => {
      if (error.response.status === 404) {
        this.setState({showNotFound: true, isLoading: false})
      }
    })
  }

  render () {
    const { info, isLoading, showNotFound } = this.state
    return (
      <div className="HorseInfo">
        {isLoading ? <HorseLoading />
          : showNotFound ? <NotFound route={this.props.location} />
            : <Grid>
              <Row className="Wraper">
                <Helmet>
                  <title>Iaho</title>
                  <meta name="description" content={HorseInfoScreen.makeHorseDescription(info)} />
                  <meta property="og:title" content={info.name} />
                  <meta property="og:locale" content="fa_IR" />
                  <meta property="og:type" content="website" />
                  <meta property="og:site_name" content="ایاهو | موتور جستجوی اسب اصیل" />
                  <meta property="og:description" content={HorseInfoScreen.makeHorseDescription(info)} />
                  <meta property="og:image" content={HorseInfoScreen.prepareHorseImage(info)} />
                  <meta property="og:url" content="https://iaho.ir/" />
                  <meta property="twitter:description" content={HorseInfoScreen.makeHorseDescription(info)} />
                  <meta property="twitter:card" content="ایاهو؛ موتور جستجوی اسب اصیل" />
                  <meta name="twitter:image:alt" content={info.name} />
                </Helmet>
                <Col lg={5} lgOffset={1} md={6} mdOffset={0} sm={10} smOffset={1} xs={12} xsOffset={0}>
                  <HorseDetails info={info} />
                  <HorseBreederOwner horse={info} />
                  <HorseChildren horse={info} children={info.childs} />
                </Col>
                <Col lg={5} lgOffset={0} md={6} mdOffset={0} sm={10} smOffset={1} xs={12} xsOffset={0}>
                  {window.__BROWSER_ENV__ && <HorsePhotos horse={info} photos={info.photos} />}
                </Col>
              </Row>
            </Grid>
        }
      </div>
    )
  }
}

HorseInfoScreen.makeHorseDescription = (data) => {
  const dam = data.dam.name ? data.dam.name : 'نامشخص'
  const sire = data.sire.name ? data.sire.name : 'نامشخص'
  return 'پدر: ' + sire + ' مادر:' + dam
}

HorseInfoScreen.prepareHorseImage = (data) => (data.avatar ? data.avatar : 'https://iaho.ir/horse.jpg')

HorseInfoScreen.fetchData = ({params}) => {
  return Actions.horseInfo(params.key)
}

function mapStateToProps (state) {
  return {
    currentHorse: state.horse.currentHorse
  }
}

export default connect(mapStateToProps)(HorseInfoScreen)



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseInfoScreen.js